export default __webpack_public_path__ + "static/media/SSL-Secure.83a561c8.png";